import React from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import Constants from "../../constants";
import { Delimiter } from "../../models/delimiter";
import { Item } from "../../models/item";
import { getSideMenuOpen } from "../../store/sagas/selectors";
import CustomScrollbar from "../CustomScrollbar/CustomScrollbar";
import { ItemList } from "../Item/ItemList";

/* Desktop menu component */

const Container = styled.div`
    position: absolute;
    width: ${Constants.sideMenuWidth}px;
    height: 75%;
    top: 5%;
    left: 0;
    overflow: hidden;
    z-index: 10;
`;

const SlidingMenu = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    left: -100%;
    transition: left 0.5s ease;
    &.open {
        left: 0;
    }
`;

export const Menu = ({ items, selectedMenu }: { items: (Item | Delimiter)[] | null; selectedMenu: any }) => {
    const menuOpen = useSelector(getSideMenuOpen);

    return (
        <Container>
            <SlidingMenu className={menuOpen ? "open" : ""}>
                <CustomScrollbar maxHeight="100%" renderLeftSide hideFade>
                    <ItemList key={selectedMenu} items={items} />
                </CustomScrollbar>
            </SlidingMenu>
        </Container>
    );
};
